import { getProvider, getWeb3 } from ".";
import config from "../../config/config";

import MafiaJailAbi from "../../abis/MafiaJail.json";

export const getMafiaJailContract = (provider = false) => {
  const web3 = provider ? getProvider() : getWeb3();
  const contractAddress = config.jailAddress;
  const MafiaJailContract = new web3.eth.Contract(
    MafiaJailAbi,
    contractAddress
  );
  return MafiaJailContract;
};

export const isUserInJail = async (userAddress: string) => {
  const MafiaJailContract = getMafiaJailContract();
  const isInJail = await MafiaJailContract.methods
    .isUserInJail(userAddress)
    .call();
  return isInJail;
};

export const getJailedUntil = async (userAddress: string) => {
  const MafiaJailContract = getMafiaJailContract();
  const jailedUntilTime = await MafiaJailContract.methods
    .jailedUntil(userAddress)
    .call();
  return Number(jailedUntilTime);
};

export const getCrimeType = async (userAddress: string) => {
  const MafiaJailContract = getMafiaJailContract();
  const crimeType = await MafiaJailContract.methods
    .prisonerCrimeType(userAddress)
    .call();
  return Number(crimeType);
};

export const buyOut = async (userAddress: string, account: string) => {
  const MafiaJailContract = getMafiaJailContract(true);
  console.log({ userAddress, account });
  const buyOut = await MafiaJailContract.methods.buyOut(userAddress).send({
    from: account,
  });
  return buyOut;
};

export const bustOut = async (userAddress: string, account: string) => {
  const MafiaJailContract = getMafiaJailContract(true);
  const bustOut = await MafiaJailContract.methods.bustOut(userAddress).send({
    from: account,
  });
  return bustOut;
};

export const getBustOutInfo = async (userAddress: string) => {
  const MafiaJailContract = getMafiaJailContract();
  const bustOutInfo = await MafiaJailContract.methods
    .bustOutInfo(userAddress)
    .call();
  return bustOutInfo;
};

export const getNextBustOutTime = async (userAddress: string) => {
  const MafiaJailContract = getMafiaJailContract();
  const nextBustOutTime: number = await MafiaJailContract.methods
    .nextBustOutTime(userAddress)
    .call();
  return Number(nextBustOutTime);
};
